/* eslint-disable */

import EVENTS from '@/utils/Constants/Events';

import { rebindAll } from '@/delonghi/Controllers/Listing/index';
import { updateProductsPositionForGTMListing } from '@/utils/Controllers/GTM/Utils';
import { emitGtmListingImpression } from '@/utils/Controllers/GTM/Operations/ListingImpression';

const updateResults = res => {
  const el = document.getElementById('js-del-plp-wrapper');
  el.innerHTML = res;
  rebindAll();
  el.querySelectorAll('a,button,[tabindex]').forEach(tileFocusableElement => {
    tileFocusableElement.addEventListener('focus', e => {
      document
        .querySelectorAll('.js-product-tile.hover')
        .forEach(tile => tile.classList.remove('hover'));
      e.target.closest('.js-product-tile').classList.add('hover');
    });
  });
};

const appendResults = ({ html, gtmEvent = null, lastPage }) => {
  const el = document.getElementById('js-del-plp-wrapper');
  const listingLimitEl = document.getElementById('js-listing-page-limit');
  listingLimitEl.insertAdjacentHTML('beforebegin', html);
  DLG.EVE.emit(EVENTS.RESULTS.UPDATE);
  el.removeChild(listingLimitEl);
  DLG.EVE.emit(EVENTS.LISTING.RESULTS.PAGEUPDATE, lastPage);
  rebindAll();
  el.querySelectorAll('a,button,[tabindex]').forEach(tileFocusableElement => {
    tileFocusableElement.addEventListener('focus', e => {
      document
        .querySelectorAll('.js-product-tile.hover')
        .forEach(tile => tile.classList.remove('hover'));
      e.target.closest('.js-product-tile').classList.add('hover');
    });
  });
  if (gtmEvent) {
    updateProductsPositionForGTMListing();
    emitGtmListingImpression(gtmEvent);
  }
};

export default () => {
  DLG.EVE.on(EVENTS.LISTING.RESULTS.UPDATE, updateResults);
  DLG.EVE.on(EVENTS.LISTING.RESULTS.APPEND, appendResults);
};
